import { render, staticRenderFns } from "./SubscribeSection.vue?vue&type=template&id=45c9e022&scoped=true"
import script from "./SubscribeSection.vue?vue&type=script&lang=js"
export * from "./SubscribeSection.vue?vue&type=script&lang=js"
import style0 from "./SubscribeSection.vue?vue&type=style&index=0&id=45c9e022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c9e022",
  null
  
)

export default component.exports